module.exports = __webpack_public_path__ + "static/media/thumbnail.b4608d9d.jpg";